import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "user-modal__header" };
const _hoisted_2 = { class: "user-modal__title" };
const _hoisted_3 = ["action"];
const _hoisted_4 = {
    type: "submit",
    class: "button button--light"
};
const _hoisted_5 = { class: "user-modal__section" };
const _hoisted_6 = { class: "user-modal__info" };
const _hoisted_7 = { class: "user-modal__label" };
const _hoisted_8 = { class: "user-modal__value" };
const _hoisted_9 = { class: "user-modal__info" };
const _hoisted_10 = { class: "user-modal__label" };
const _hoisted_11 = { class: "user-modal__value" };
const _hoisted_12 = ["value", "selected"];
const _hoisted_13 = { class: "user-modal__section" };
const _hoisted_14 = { class: "user-modal__info" };
const _hoisted_15 = { class: "user-modal__label" };
const _hoisted_16 = { class: "user-modal__value" };
const _hoisted_17 = ["value"];
const _hoisted_18 = {
    key: 2,
    class: "alert alert--error"
};
const _hoisted_19 = { class: "user-modal__info" };
const _hoisted_20 = { class: "user-modal__label" };
const _hoisted_21 = { class: "user-modal__value" };
const _hoisted_22 = {
    key: 0,
    class: "user-modal__info"
};
const _hoisted_23 = { class: "user-modal__label" };
const _hoisted_24 = { class: "user-modal__value" };
import { onMounted, ref } from 'vue';
import Modal from '@astina/paloma-common-ui/src/components/Modal.vue';
import Spinner from '@astina/paloma-common-ui/src/components/Spinner.vue';
import CsrfFormField from '@astina/paloma-common-ui/src/components/CsrfFormField.vue';
import env from '../services/AppEnv';
import customers from '@astina/paloma-shop-common-ui/src/services/CustomerRepository';
import AppAddress from "@astina/paloma-shop-common-ui/src/components/AppAddress.vue";
import { activateCustomer } from '../commands/ActivateCustomer';
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserModal',
    emits: [
        'close'
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const user = env.user;
        const logoutUrl = ref(`${env.path}/logout`);
        const customer = ref(env.customer);
        const customerId = ref(env.customer.id);
        const customersValue = ref([]);
        const locale = ref(env.locale);
        const locales = ref(env.translations.locales);
        const address = ref(null);
        const loading = ref(false);
        const error = ref(false);
        onMounted(() => {
            customers.getCustomer()
                .then(customer => address.value = customer.shippingAddress || null)
                .catch(() => address.value = null);
            customers.listCustomers()
                .then(c => customersValue.value = c)
                .catch(() => customersValue.value = []);
        });
        function selectCustomer() {
            if (!customerId.value) {
                return;
            }
            loading.value = true;
            error.value = false;
            activateCustomer(customerId.value)
                .then(() => {
                window.location.href = env.path + '/';
            })
                .catch(() => {
                loading.value = false;
                error.value = true;
                customerId.value = '';
            });
        }
        function selectLanguage() {
            window.location.href = langUrl(locale.value);
        }
        function close() {
            emit('close');
        }
        function langUrl(locale) {
            const current = window.location.href.replace(/([?&])_lang=[a-z_]{2,5}/, '');
            return current + (current.indexOf('?') === -1 ? '?' : '&') + '_lang=' + locale;
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createBlock(Modal, {
                onClose: close,
                class: "user-modal",
                classes: ['modal--medium']
            }, {
                body: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(user).firstName) + " " + _toDisplayString(_unref(user).lastName), 1),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("form", {
                            class: "user-modal__logout",
                            method: "post",
                            action: logoutUrl.value
                        }, [
                            _createElementVNode("button", _hoisted_4, [
                                _createVNode(_component_icon, { name: "sign-out" }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('login.sign-out')) + " ", 1),
                                _createVNode(CsrfFormField)
                            ])
                        ], 8, _hoisted_3)
                    ]),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('emailAddress')), 1),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(user).emailAddress), 1)
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('customer.locale')), 1),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_11, [
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((locale).value = $event)),
                                    onChange: selectLanguage
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locales.value, (loc) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: loc,
                                            value: loc,
                                            selected: loc === locale.value
                                        }, _toDisplayString(loc.toUpperCase()), 9, _hoisted_12));
                                    }), 128))
                                ], 544), [
                                    [_vModelSelect, locale.value]
                                ])
                            ])
                        ])
                    ]),
                    _cache[13] || (_cache[13] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('customer.client')), 1),
                            _cache[7] || (_cache[7] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_16, [
                                (customersValue.value.length <= 1)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(customer.value.company), 1)
                                    ], 64))
                                    : _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 1,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((customerId).value = $event)),
                                        onChange: selectCustomer
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customersValue.value, (c) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                value: c.id,
                                                key: c.id
                                            }, _toDisplayString(c.company), 9, _hoisted_17));
                                        }), 128))
                                    ], 544)), [
                                        [_vModelSelect, customerId.value]
                                    ]),
                                _cache[6] || (_cache[6] = _createTextVNode()),
                                (error.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('command.activate_customer.error')), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _cache[11] || (_cache[11] = _createTextVNode()),
                        (loading.value)
                            ? (_openBlock(), _createBlock(Spinner, {
                                key: 0,
                                loading: true
                            }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('customer.customerNumber')), 1),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_21, _toDisplayString(customer.value.customerNumber), 1)
                                ]),
                                _cache[10] || (_cache[10] = _createTextVNode()),
                                (address.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('address')), 1),
                                        _cache[9] || (_cache[9] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_24, [
                                            _createVNode(AppAddress, { address: address.value }, null, 8, ["address"])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 64))
                    ])
                ]),
                _: 1
            }));
        };
    }
});
